export const BIOMARKER = 'biomarker';
